import { Namespace } from '_core/utils/ssr';

export const providersConfig = {
  i18nNamespaces: ['common', 'agency', 'quotes', 'howItWorks', 'briefing', 'providers'] as Namespace,
};
